export default __webpack_public_path__ + "static/media/logotype.4447e20b.svg";